export interface Invoice {
  id: string;
  invoiceNumber: string;

  // Purchase Info
  itemId: string;
  itemName: string;
  itemCollection: string;
  itemImage: string;
  auctionType: 'English' | 'Dutch' | 'Vickrey' | 'Candle';

  // Pricing
  priceCrypto: number;
  currency: string;
  priceEur: number;
  feePercentage: number;
  feeAmount: number;
  totalCrypto: number;
  totalEur: number;

  // Transaction Details
  txHash: string;
  blockNumber: number;
  network: string;
  chainId: number;

  // Dates
  purchaseDate: Date;
  invoiceDate: Date;

  // Buyer Info
  buyerAddress: string;
  buyerName?: string;
  buyerEmail?: string;

  // Seller Info
  sellerAddress: string;
  sellerName?: string;

  // Company Info (NARDIHA Holdings S.L.)
  company: {
    name: string;
    legalName: string;
    cif: string;
    address: string;
    city: string;
    postalCode: string;
    country: string;
    email: string;
    website: string;
  };

  // Status
  status: 'pending' | 'completed' | 'cancelled';
}

export interface InvoiceListItem {
  id: string;
  invoiceNumber: string;
  itemName: string;
  itemImage: string;
  priceCrypto: number;
  currency: string;
  priceEur: number;
  purchaseDate: Date;
  status: 'pending' | 'completed' | 'cancelled';
}

export const COMPANY_INFO = {
  name: 'TEMPLUM DAO',
  legalName: 'NARDIHA Holdings S.L.',
  cif: 'B12345678',
  address: 'Calle Ejemplo 123, Planta 4',
  city: 'Barcelona',
  postalCode: '08001',
  country: 'España',
  email: 'invoices@templum.io',
  website: 'https://templum.io',
};

export const NETWORK_INFO = {
  name: 'Polygon',
  chainId: 137,
  explorerUrl: 'https://polygonscan.com',
};
